import http from './httpService'

const API_ENDPOINT = import.meta.env.VITE_API_PASARELA_EBM

export const crearPreferencia = (body) => {
  return http.post(`${API_ENDPOINT}/mp/payments/preference/`, body)
}

export const recibirUrlAutorizacion = (body) => {
  return http.post(`${API_ENDPOINT}/mp/oauth/url`, body)
}

export const recibirUserInfo = (body) => {
  return http.post(`${API_ENDPOINT}/mp/payments/getUserData`, body)
}

export const refund = (body) => {
  return http.post(`${API_ENDPOINT}/mp/payments/refund`, body)
}
